import { render } from "./Captcha.vue?vue&type=template&id=a87e9552"
import script from "./Captcha.vue?vue&type=script&lang=js"
export * from "./Captcha.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tomasfic/Projects/osobni/kometa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__